module.exports = __webpack_public_path__ + "static/media/Schoolhealth2.84c707a9.jpg";